/*
 * @Author: lbh
 * @Date: 2020-12-24 18:12:01
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-25 18:04:13
 * @Description: file content
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 導入 vue 框架
import Vue from "vue";
// * 導入根組件
import App from "./App.vue";
// * 導入路由
import router from "./router";
// * 導入 vuex
import store from "./store";
// * 導入請求
import http from "./js/util/http";
// * 導入工具類
import util from "./js/util/util";
// * 導入工具類2
import common from "./js/commn/index";
// * 導入 緩存 key
import K from "./js/util/loca_key";
import s_log from "./js/util/logs";
// * 導入點擊流
import point from "./js/util/point";
// * 導入 美團日誌
import logan from "./js/util/logan";
import larkError from "./js/util/larkError";
// 導入 html 轉 pdf
import htmlToPdf from "./js/util/htmlToPdf";
// 導入 vant
import Vant from "vant";
import "vant/lib/index.css";

import elementui from "./js/util/elementui";

import lodash from "./js/util/lodash";
import decimal from "./js/util/decimal";
import payUtil from "./js/util/pay";
import _toast from "./js/util/toast";

/**
 * 引入i18n国际化
 */
import i18n from "./i18n/index";
// import "../src/assets/css/common.css";

// 導入圖形校驗
import SlideVerify from "vue-monoplasty-slide-verify";
// 導入 vConsole
import vConsole from "vconsole";
// 導入 vant 懶加載
import { Lazyload } from "vant";

import font from "./js/fontMode/font";

import selfImage from "@/components/do/image.vue";
import selfFooter from "@/components/do/footer.vue";
import payLoading from "./components/com/payLoading";

import storage from "./js/util/storage";
import fp from "./js/util/fp";

K.clearLoca();
i18n.setLocale();
fp();

// 關閉生產模式給的提示
Vue.config.productionTip = false;

// * 設置微信自定義標籤
Vue.config.ignoredElements = ["wx-open-subscribe"];

// Vue.config.devtools = true;
Vue.use(Vant);
Vue.use(elementui);
Vue.use(Lazyload);
Vue.use(SlideVerify);
Vue.use(payLoading);
Vue.component("selfImage", selfImage);
Vue.component("selfFooter", selfFooter);
Vue.use(font);
Vue.use(storage);
Vue.use(decimal);
Vue.use(lodash);
Vue.use(payUtil);
Vue.use(_toast);

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(htmlToPdf);
Vue.prototype.$util = util;
Vue.prototype.$point = point;
Vue.prototype.$I = common;
Vue.prototype.$K = K;

// ? 初始化全局異常捕獲，暫不接管 Promise callback 包裝
larkError.install(Vue, { promise: false, dev: false });
// 設置版本號
Vue.prototype.appVersion = "1.0.14";
Vue.prototype.isRefresh = true;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  beforeCreate() {
    // 初始化 主題色
    util.getCountryFun();
    util.setSystemTheme();

    // util.getImageConfigFun();
  },
  created() {
    // * 全局設置 系統返回方法
    window.back = () => {
      router.back();
    };
    try {
      "".replaceAll("", "");
    } catch (e) {
      String.prototype.replaceAll = function (replaceStr, newStr) {
        return this.replace(new RegExp(replaceStr, "gm"), newStr);
      };
    }
    // 判斷是不是測試環境
    if (
      location.origin.indexOf(".com") == -1 ||
      location.origin.indexOf("hktest") > -1 ||
      location.origin.indexOf("prf-m.ricepon") > -1 ||
      location.origin.indexOf("pay.ricepon.com") > -1
      //  && location.origin.indexOf("8090") == -1
    ) {
      // 加載調試工具
      if (localStorage.getItem("hideVConsole") != "hidden") new vConsole();
    } else {
      // 嫣風 ,  博華 , 鄢風 , 長今
      let users = ["824202", "128673", "1336650", "41201"];
      let id = util.userInfoFun.get().id;
      if (id && users.indexOf(id) > -1) {
        new vConsole();
      }
    }

    util.setKeyword();

    // 初始化 頭部信息
    http.setHeaders();
    // 初始化用戶登錄狀態.
    if (localStorage.getItem(K.user_id) && localStorage.getItem(K.user_phone)) {
      store.commit("setHasLogin", true);
    }
    // 初始化 語言
    // Vue.prototype.appLanguage = "zh-hk";

    window.onload = function () {
      // 阻止双击放大
      var lastTouchEnd = 0;
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
      // 阻止双指放大
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
    // 定制app 的方法
    window.init = {
      back() {
        history.back();
      },
    };
    // 監聽 頁面旋轉
    window.onorientationchange = (e) => {
      let orientation = window.orientation;
      if (orientation == 90 || orientation == -90) {
        util.setPhoneRotate();
      } else {
        if (document.getElementById("preventTran")) {
          document.getElementById("preventTran").remove();
        }
        // location.reload();
        setTimeout(function () {
          document.querySelector("body").scrollTop = 10;
        }, 500);
      }
    };
  },
  mounted() {
    setTimeout(() => {
      document.dispatchEvent(new Event("render-event"));
    }, 500);
    // 判斷是否是pc
    if (util.IsPC()) {
      if (location.search.includes("a=0")) {
        console.log("凱奇後台定制版!");
      } else {
        document.querySelector("#app").classList.add("pc_app");
        document.querySelector(".app_content").classList.add("pc_content");
      }
    }
  },
}).$mount("#app");
